import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { NavigationBar } from 'customer_portal-ui-shared';

const SubHeader = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedMenu, setSelectedMenu] = useState<string>('');

    const navigationItems = {
        Tracker: {
            selectBy: 'Tracker',
            action: () => {
                setSelectedMenu(navigationItems.Tracker.selectBy);
                navigate('/');
            },
            label: 'Filter'
        },
        Vessels: {
            selectBy: 'Vessels',
            action: () => {
                setSelectedMenu(navigationItems.Vessels.selectBy);
                navigate('/vessel');
            },
            label: 'Vessels'
        },
        Calendar: {
            selectBy: 'Calendar',
            action: () => {
                setSelectedMenu(navigationItems.Calendar.selectBy);
                navigate('/calendar');
            },
            label: 'Calendar'
        }
    };

    useEffect(() => {
        const path = location.pathname;
        if (path === '/') {
            setSelectedMenu(navigationItems.Tracker.selectBy);
        } else if (path.startsWith('/vessel')) {
            setSelectedMenu(navigationItems.Vessels.selectBy);
        } else if (path.startsWith('/calendar')) {
            setSelectedMenu(navigationItems.Calendar.selectBy);
        }
    }, [location.pathname]);

    return <NavigationBar data={navigationItems} selected={selectedMenu} history={1} />;
};

export default SubHeader;
